import React, { FC, useEffect, useState } from 'react';
import { NewPasswordCont } from './NewPassword.styles';
import NewPasswordConfirm from '../../components/ResetPassword/NewPassword/NewPasswordConfirm/NewPasswordConfirm';
import NewPasswordForm from '../../components/ResetPassword/NewPassword/NewPasswordForm/NewPasswordForm';
import { useResetPassword } from '../../hooks/useResetPassword';

interface IApiError {
  title: string | null;
  description: string | null;
}

const apiErrorInit = { title: null, description: null };

const NewPassword: FC = () => {
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [apiError, setApiError] = useState<IApiError>(apiErrorInit);
  const [isValidToken, setIsValidToken] = useState(true);
  const { validateToken, getToken, confirm } = useResetPassword();
  const token = getToken();

  useEffect(() => {
    validateToken({ token: token }).then(resp => {
      setIsValidToken(resp);
      setIsConfirmed(!resp);
    });
    setTimeout(() => {
      setIsValidToken(false);
    }, 60 * 1000 * 15);
  }, []);

  const changePassword = (password: string) => {
    confirm({ password: password, token: token })
      .then(() => {
        setIsConfirmed(true);
      })
      .catch(error => {
        const details = error.data.details;
        const isDetailsObject = typeof details === 'object' && details !== null;
        const description = isDetailsObject ? details[Object.keys(details)[0]][0] : details;
        const errorMessage = {
          title: error.data.title,
          description: description,
        };
        setApiError(errorMessage);
      });
  };

  return (
    <NewPasswordCont>
      {isValidToken ? (
        !isConfirmed ? (
          <NewPasswordForm changePassword={changePassword} apiError={apiError} />
        ) : (
          <NewPasswordConfirm isSuccessful={true} />
        )
      ) : (
        <NewPasswordConfirm isSuccessful={false} />
      )}
    </NewPasswordCont>
  );
};

export default NewPassword;
